// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1A3lc","list":"styles_list__3h6vO"};